export default __webpack_public_path__ + "static/media/osvc.f4a31b95.webp";